import React, { useCallback, useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  Typography,
  LinearProgress,
  Box,
} from '@mui/material'
import { metodoPrograma } from '../../../components/api'

const CardProgresso = ({ dados, monitorando }) => {
  const [percentual, setPercentual] = useState(0)

  const getProcesso = useCallback(() => {
    if (!dados?.idCampanha) return

    metodoPrograma('getProcesso', {
      idCampanha: dados.idCampanha,
    }).then((res) => {
      if (res.status) {
        setPercentual(res.percentualEnvio)
      }
    })
  }, [dados?.idCampanha])

  useEffect(() => {
    if (!monitorando) return

    const interval = setInterval(() => {
      getProcesso()
    }, 1000)

    return () => clearInterval(interval)
  }, [monitorando, getProcesso])

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 3,
      }}
    >
      <CardContent>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ mt: 1 }}
        >
          <Typography fontSize={15} fontWeight="300" color="primary">
            {percentual}%
          </Typography>
        </Box>

        <LinearProgress
          variant="determinate"
          value={percentual}
          sx={{
            mt: 2,
            height: 10,
            borderRadius: 5,
          }}
        />
      </CardContent>
    </Card>
  )
}

export default CardProgresso
